<template>
    <div>
        <div v-if="!initialized">
            <span>Loading...</span>
        </div>
        <div v-else>
            <div v-if="description" class="alert alert-info">{{ description }}</div>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Door/Model</th>
                        <th v-for="row in rows" class="text-center">{{ row.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="col in cols">
                        <td><strong>{{ col.name }}</strong></td>
                        <td v-for="row in rows">
                            <input :key="row.id + '_' + col.id + '-' + timestamp" type="number"
                                v-model="matrix[row.id + '-' + col.id].value" class="form-control text-center">
                        </td>
                    </tr>
                </tbody>
            </table>
            <button type="button" class="btn btn-rounded btn-icon btn-sm btn-primary mt-3" v-on:click="submitMatrix">
                <i class="material-icons">save</i>Save
            </button>
        </div>
    </div>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import Promise from 'bluebird';

export default {
    data() {
        return {
            initialized: false,
            rows: [],
            cols: [],
            matrix: {

            },
        }
    },

    props: [
        'content', 'contentType', 'parent',
        'relationship', 'timestamp', 'section', 'config',
        'updateBatch', 'createData', 'updateData', 'deleteData',
    ],

    components: {
        VueSpinner: MoonLoader,
    },

    mounted() {
        const config = this.config;
        this.$emit('content::initialized', {
            type: this.content.type,
            name: 'matrix-input-component',
            config,
        });

        const api = this.helpers('api');

        Promise.all([
            api.getData(this.rowEndpoint),
            api.getData(this.colEndpoint),
        ]).then(([rows, cols]) => {
            this.rows = rows.data;
            this.cols = cols.data;
            this.initialized = true;
            this.matrix = this.prepareMatrix(this.content);
            this.$forceUpdate();
        })
    },

    watch: {
        timestamp() {
            this.matrix = this.prepareMatrix(this.content);
            this.$forceUpdate();
        }
    },

    computed: {
        rowEndpoint() {
            return _.get(this.config, 'rowEndpoint');
        },
        colEndpoint() {
            return _.get(this.config, 'colEndpoint');
        },
        rowField() {
            return _.get(this.config, 'rowField');
        },
        colField() {
            return _.get(this.config, 'colField');
        },
        valueField() {
            return _.get(this.config, 'valueField');
        },
        description() {
            return _.get(this.config, 'description');
        },
    },

    methods: {
        prepareMatrix(content) {
            const matrix = _.chain(content)
                .get('data', [])
                .map(_.property('attributes'))
                .map(item => {
                    const rowKey = _.get(item, this.rowField, '0');
                    const colKey = _.get(item, this.colField, '0');
                    const key = rowKey + '-' + colKey;
                    const value = _.get(item, this.valueField, null);

                    return [key, { value, id: item.id, rowKey, colKey }];
                }).fromPairs().value();

            this.rows.forEach((row) => {
                this.cols.forEach((col) => {
                    const key = `${row.id}-${col.id}`;

                    if (!_.has(matrix, key)) {
                        matrix[key] = {
                            value: null,
                            id: null,
                            rowKey: row.id,
                            colKey: col.id,
                        }
                    }
                })
            })

            return matrix;
        },

        submitMatrix() {
            const data = _.chain(this.matrix)
                .values()
                .map((cell) => {

                    const cellData = {
                        [this.rowField]: cell.rowKey,
                        [this.colField]: cell.colKey,
                        [this.valueField]: cell.value,
                    }

                    if (!cell.id) {
                        return {
                            id: null,
                            $create: cellData,
                        }
                    }

                    return {
                        id: cell.id,
                        $update: cellData,
                    }
                }).value();

            return this.updateBatch(data, {
                setNotification: true,
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/MatrixInputComponent.vue